import Marquee from "react-fast-marquee";

const EditorialMarquee = ({ items = ["LOCATION HAS ENERGY", "TIME HAS MEMORY"], className = "" }) => (
  <div data-testid="editorial-marquee" className={`border-y border-white/10 py-8 md:py-10 overflow-hidden ${className}`}>
    <Marquee speed={25} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-semibold text-3xl md:text-5xl text-bone/90 tracking-tight mx-8 md:mx-12">
            {item}
          </span>
          <span className="font-mono text-brand text-xl md:text-2xl mx-2">///</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
